(function () {
    'use strict';
    $(document).ready(function () {

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        $('#v-pills-tab a.nav-link').on('click', function () {
            if (window.matchMedia("(max-width: 767px)").matches) {
                $(this).next().slideToggle();
            }
        });

        var fixedBg = $('.fixed-bg');
        if (fixedBg.length) {
            calculateFixedBg();
            $(window).on('resize', calculateFixedBg);
        }

        $("a.smooth-scroll").click(function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(href).offset().top - $('header').height()
            }, 1000);
        });

        function calculateFixedBg() {
            var columnWidth = fixedBg.parent().width();
            var containerWidth = fixedBg.parent().parent().parent().width();
            var screenWidth = $(document).width();

            fixedBg.find('img').width(columnWidth + 30 + (screenWidth - containerWidth) / 2);
        }

        //Offer tabs
        const selectOfferTab = (index = 0) => {
            if ($('main.offer').length) {
                const $a = $('.offer-tabs-navigation .offer-tabs-nav li').eq(index).find('>a');
                const $tab = $('.offer-tabs .offer-tab').eq(index);
                $a.addClass('active');
                $a.parent().siblings().children().removeClass('active');
                $tab.fadeIn();
                $tab.siblings().hide();
            }
        }

        $('.offer-tabs-navigation .offer-tabs-nav a').each(function (index) {
            if ($(this).data('id') === location.hash) selectOfferTab(index);
            $(this).on('click', () => selectOfferTab(index));
        });

        // SOCIAL SHARING
        const $share = $('#share');
        $share.css('opacity', 1);
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });

        if ($('.ipbox').length) {

            ScrollTrigger.matchMedia({
                "(min-width: 769px)": function () {
                    let st = ScrollTrigger.create({
                        trigger: ".step-by-step",
                        pin: ".questions-widget",
                        start: "top top+=140px",
                        endTrigger: "footer",
                        end: "bottom bottom+=100px"
                    });
                }
            })
        }
    });
}(jQuery));
